import { Component, OnInit, Output, EventEmitter, Inject,ViewChild,TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '../../core/services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from '../../core/services/event.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { Observable, of, Subscription } from 'rxjs';
import { MenuEvent } from 'src/app/core/services/menuevent.service';
import { MenuService } from '../../core/services/menu.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {

  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;
  strWsURL: string = "api/mantenimientos/Favoritos/SEL/0";
  strWsnoti: string = "api/servicios/Notificaciones";
  strActualizarNoti : string = "api/servicios/ActualizarEstadoNotificacion";
  megamenu: any[] = [];
  array: Array<string> = [];
  notificaciones: Array<string> = [];
  WsLlaves : string = '';
  cantidad: any;
  id : string = '';

  constructor(@Inject(DOCUMENT) private document: any, private router: Router, private authService: AuthenticationService,
              public languageService: LanguageService,
              public translate: TranslateService,
              public _cookiesService: CookieService,
              private dataService: SharedService,
              private menuEvent: MenuEvent,
              public menuService: MenuService,
              private modalService: NgbModal,
    		  private eventService: EventService) {
  }

  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();
  @Output() pant_horizontal = new EventEmitter();
  @ViewChild('contenido') contenido:TemplateRef<any>;
  suscription : Subscription = null; 
  menuItems = [];

  ngOnInit() {
    this.initialize();
    this.initialize2();
    this.openMobileMenu = false;
    this.element = document.documentElement;

    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
  }

  initialize(): void { 
    this.megamenu = [];
    this.dataService.Consultar(this.strWsURL).subscribe(
      (datosResp: any) => {       
        this.array = datosResp;
        var opmegamenu : any = [];
        this.array.sort((a,b) => {      
          if(a["SYS02DES"].toLowerCase() > b["SYS02DES"].toLowerCase()){
            return 1;
          }
          if(a["SYS02DES"].toLowerCase() < b["SYS02DES"].toLowerCase()){
            return -1;
          }
          return 0;
        })
        var contador = 0;   
        for (var i=0; i < this.array.length;i++){
          opmegamenu.push(this.array[i]);   
          contador ++; 
         if(contador > 3){
            this.megamenu.push(opmegamenu);  
            opmegamenu = []; 
            contador = 0;
          }
        } 
        this.megamenu.push(opmegamenu);
      });
      
     
    
    
   
 }
 AbrirNotificacion(){
  this.menuEvent.broadcast('ABRIR_NUEVO_TAB', JSON.parse("{ \"SYS02CON\" : \"" + "0" + "\", \"titulo\": \"" + "Notificaciones" + "\", \"Tipo\": \"NOTIFICACION_COMPONENT\",\"PAD18CON\": \"14234\"}"));
  this._removeAllClass('show');
 }
AbrirArchivos(){
  this.menuEvent.broadcast('ABRIR_NUEVO_TAB', JSON.parse("{ \"SYS02CON\" : \"" + "0" + "\", \"titulo\": \"" + "Archivos" + "\", \"Tipo\": \"ARCHIVOS_COMPONENT\",\"PAD18CON\": \"142345\"}"));
}
AbrirProfile(){
  this.menuEvent.broadcast('ABRIR_NUEVO_TAB', JSON.parse("{ \"SYS02CON\" : \"" + "0" + "\", \"titulo\": \"" + "Perfil" + "\", \"Tipo\": \"PROFILE_COMPONENT\",\"PAD18CON\": \"142345\"}"));
}
 initialize2(): void {
  //notificaciones
  this.dataService.Consultar(this.strWsnoti).subscribe((datosResp2: any) => {       
     this.notificaciones = datosResp2;
     var data_filter = datosResp2.filter( element => element.PAD18EST == "N")
     this.notificaciones = data_filter;
     this.cantidad = data_filter.length; 
   });
};
EventoClickLista(index,id) {   
  this.WsLlaves = index;
  this.id =  index;
  this.markUnread();
  this.modalService.open(this.contenido, { size: 'xl' });    
} 
markUnread() {
  this.dataService.Consultar(this.strActualizarNoti+"/"+this.id+"/"+"S").subscribe((datosResp3: any) => {
    this.notificaciones = datosResp3
    this.initialize2();
  });
}  
 cargarToolbar(){
  this.initialize();
 }
 AbrirMenu(intSYS02CON, descripcion){
  this.menuEvent.broadcast('ABRIR_NUEVO_TAB', JSON.parse("{ \"SYS02CON\" : \"" + intSYS02CON + "\", \"titulo\": \"" + descripcion + "\"}"));
  this._removeAllClass('show');
}
_removeAllClass(className) {
  const els = document.getElementsByClassName(className);
  while (els[0]) {
    els[0].classList.remove(className);
  }
}

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {    
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }
  
  /**
   * Logout the user
   */
  logout() {
      this.authService.logout();
    this.router.navigate(['/account/login']);
  }

  toggleHorizontalLayout() {
    this.eventService.broadcast('changeLayout', 'horizontal');
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
}
